document.addEventListener('DOMContentLoaded', function () {

    const bar = document.querySelector('.announcement-bar');
    const section = document.querySelector('.announcement-bar-section');
    const button = document.querySelector('.announcement-bar__close');

    if (!bar || !button || !section) return;

    const version = "announcement-v1";

    // Hide if already dismissed
    if (localStorage.getItem(version) === "closed") {
        section.style.display = "none";
        return;
    }

    button.addEventListener('click', function (e) {

        e.preventDefault();
        e.stopPropagation();

        section.classList.add("announcement-closing");

        localStorage.setItem(version, "closed");

        section.addEventListener("transitionend", function () {
            section.style.display = "none";
        }, { once: true });

    });

});